jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

document.addEventListener('DOMContentLoaded', function() {
    
    const ShopeeLabels = {
        
        init: function() {
            this.handleResponsiveLabels();
            this.handleResponsivePaymentSquares();
            this.addLabelInteractions();
            this.addPaymentSquareInteractions();
            this.optimizeLabelsDisplay();
            this.handleLabelAnimations();
            this.handlePaymentSquareAnimations();
            
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    this.handleResponsiveLabels();
                    this.handleResponsivePaymentSquares();
                }, 250);
            });
        },
        
        handleResponsiveLabels: function() {
            const labels = document.querySelectorAll('.t4s-shopee-labels');
            const screenWidth = window.innerWidth;
            
            labels.forEach(labelContainer => {
                const labelItems = labelContainer.querySelectorAll('.t4s-shopee-label');
                
                if (screenWidth < 480) {
                    this.limitLabelsOnMobile(labelItems);
                } else if (screenWidth < 768) {
                    this.limitLabelsOnTablet(labelItems);
                } else {
                    this.showAllLabels(labelItems);
                }
            });
        },
        
        handleResponsivePaymentSquares: function() {
            const paymentContainers = document.querySelectorAll('.t4s-payment-squares');
            const screenWidth = window.innerWidth;
            
            paymentContainers.forEach(container => {
                const squares = container.querySelectorAll('.t4s-payment-square');
                
                if (screenWidth < 480) {
                    this.limitPaymentSquaresOnMobile(squares);
                } else if (screenWidth < 768) {
                    this.limitPaymentSquaresOnTablet(squares);
                } else {
                    this.showAllPaymentSquares(squares);
                }
            });
        },
        
        limitPaymentSquaresOnMobile: function(squares) {
            squares.forEach((square, index) => {
                if (index > 2) {
                    square.style.display = 'none';
                } else {
                    square.style.display = 'inline-flex';
                }
            });
            
            if (squares.length > 3) {
                this.addPaymentMoreIndicator(squares[0].parentElement, squares.length - 3);
            }
        },
        
        limitPaymentSquaresOnTablet: function(squares) {
            squares.forEach((square, index) => {
                if (index > 3) {
                    square.style.display = 'none';
                } else {
                    square.style.display = 'inline-flex';
                }
            });
            
            if (squares.length > 4) {
                this.addPaymentMoreIndicator(squares[0].parentElement, squares.length - 4);
            }
        },
        
        showAllPaymentSquares: function(squares) {
            squares.forEach(square => {
                square.style.display = 'inline-flex';
            });
            
            const moreIndicator = squares[0]?.parentElement?.querySelector('.payment-more-indicator');
            if (moreIndicator) {
                moreIndicator.remove();
            }
        },
        
        addPaymentMoreIndicator: function(container, moreCount) {
            const existingIndicator = container.querySelector('.payment-more-indicator');
            if (existingIndicator) {
                existingIndicator.remove();
            }
            
            const moreIndicator = document.createElement('div');
            moreIndicator.className = 't4s-payment-square payment-more-indicator size-small rounded with-shadow';
            moreIndicator.style.cssText = 'background: #6c757d; color: #fff; cursor: pointer; display: inline-flex; align-items: center; justify-content: center;';
            moreIndicator.innerHTML = `<span class="payment-text">+${moreCount}</span>`;
            moreIndicator.setAttribute('title', `${moreCount} طريقة دفع إضافية`);
            
            moreIndicator.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.showAllPaymentSquares(container.querySelectorAll('.t4s-payment-square:not(.payment-more-indicator)'));
            });
            
            container.appendChild(moreIndicator);
        },
        
        limitLabelsOnMobile: function(labels) {
            labels.forEach((label, index) => {
                if (index > 2) {
                    label.style.display = 'none';
                } else {
                    label.style.display = 'inline-flex';
                }
            });
            
            if (labels.length > 3) {
                this.addMoreIndicator(labels[0].parentElement, labels.length - 3);
            }
        },
        
        limitLabelsOnTablet: function(labels) {
            labels.forEach((label, index) => {
                if (index > 3) {
                    label.style.display = 'none';
                } else {
                    label.style.display = 'inline-flex';
                }
            });
            
            if (labels.length > 4) {
                this.addMoreIndicator(labels[0].parentElement, labels.length - 4);
            }
        },
        
        showAllLabels: function(labels) {
            labels.forEach(label => {
                label.style.display = 'inline-flex';
            });
            
            const moreIndicator = labels[0]?.parentElement?.querySelector('.shopee-more-indicator');
            if (moreIndicator) {
                moreIndicator.remove();
            }
        },
        
        addMoreIndicator: function(container, moreCount) {
            const existingIndicator = container.querySelector('.shopee-more-indicator');
            if (existingIndicator) {
                existingIndicator.remove();
            }
            
            const moreIndicator = document.createElement('span');
            moreIndicator.className = 't4s-shopee-label shopee-more-indicator size-small';
            moreIndicator.style.cssText = 'background: #6c757d; color: #fff; cursor: pointer;';
            moreIndicator.textContent = `+${moreCount}`;
            moreIndicator.setAttribute('title', `${moreCount} تسمية إضافية`);
            
            moreIndicator.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.showAllLabels(container.querySelectorAll('.t4s-shopee-label:not(.shopee-more-indicator)'));
            });
            
            container.appendChild(moreIndicator);
        },
        
        addLabelInteractions: function() {
            const labels = document.querySelectorAll('.t4s-shopee-label');
            
            labels.forEach(label => {
                label.addEventListener('mouseenter', function() {
                    this.style.transform = 'translateY(-2px) scale(1.05)';
                    this.style.zIndex = '20';
                });
                
                label.addEventListener('mouseleave', function() {
                    this.style.transform = 'translateY(0) scale(1)';
                    this.style.zIndex = '15';
                });
                
                label.addEventListener('click', function(e) {
                    e.stopPropagation();
                });
            });
        },
        
        addPaymentSquareInteractions: function() {
            const squares = document.querySelectorAll('.t4s-payment-square');
            
            squares.forEach(square => {
                square.addEventListener('mouseenter', function() {
                    this.style.transform = 'scale(1.1)';
                    this.style.zIndex = '18';
                });
                
                square.addEventListener('mouseleave', function() {
                    this.style.transform = 'scale(1)';
                    this.style.zIndex = '16';
                });
                
                square.addEventListener('click', function(e) {
                    e.stopPropagation();
                });
            });
        },
        
        optimizeLabelsDisplay: function() {
            const labelContainers = document.querySelectorAll('.t4s-shopee-labels');
            
            labelContainers.forEach(container => {
                const labels = container.querySelectorAll('.t4s-shopee-label');
                
                const priorityOrder = [
                    'label-free-shipping',
                    'label-voucher', 
                    'label-cashback',
                    'label-custom',
                    'label-same-day'
                ];
                
                const sortedLabels = Array.from(labels).sort((a, b) => {
                    const aIndex = priorityOrder.findIndex(p => a.classList.contains(p));
                    const bIndex = priorityOrder.findIndex(p => b.classList.contains(p));
                    return aIndex - bIndex;
                });
                
                sortedLabels.forEach(label => container.appendChild(label));
                
                if (labels.length > 1) {
                    container.classList.add('has-multiple-labels');
                }
            });
            
            const paymentContainers = document.querySelectorAll('.t4s-payment-squares');
            
            paymentContainers.forEach(container => {
                const squares = container.querySelectorAll('.t4s-payment-square');
                
                const paymentPriorityOrder = [
                    'payment-1',
                    'payment-2',
                    'payment-3',
                    'payment-4'
                ];
                
                const sortedSquares = Array.from(squares).sort((a, b) => {
                    const aIndex = paymentPriorityOrder.findIndex(p => a.classList.contains(p));
                    const bIndex = paymentPriorityOrder.findIndex(p => b.classList.contains(p));
                    return aIndex - bIndex;
                });
                
                sortedSquares.forEach(square => container.appendChild(square));
                
                if (squares.length > 1) {
                    container.classList.add('has-multiple-payments');
                }
            });
        },
        
        handleLabelAnimations: function() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const labels = entry.target.querySelectorAll('.t4s-shopee-label');
                        
                        labels.forEach((label, index) => {
                            setTimeout(() => {
                                label.style.opacity = '1';
                                label.style.transform = 'translateY(0)';
                            }, index * 100);
                        });
                    }
                });
            }, { threshold: 0.1 });
            
            document.querySelectorAll('.t4s-product').forEach(product => {
                observer.observe(product);
            });
        },
        
        handlePaymentSquareAnimations: function() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const squares = entry.target.querySelectorAll('.t4s-payment-square');
                        
                        squares.forEach((square, index) => {
                            setTimeout(() => {
                                square.style.opacity = '1';
                                square.style.transform = 'scale(1)';
                            }, index * 150 + 200);
                        });
                    }
                });
            }, { threshold: 0.1 });
            
            document.querySelectorAll('.t4s-payment-squares').forEach(container => {
                observer.observe(container);
            });
        },
        
        addDynamicLabels: function() {
            const products = document.querySelectorAll('.t4s-product');
            
            products.forEach(product => {
                const labelContainer = product.querySelector('.t4s-shopee-labels');
                if (!labelContainer) return;
                
                const productData = product.dataset.productOptions;
                if (productData) {
                    try {
                        const data = JSON.parse(productData);
                        if (data.maxQuantity <= 5 && data.maxQuantity > 0) {
                            this.addLimitedStockLabel(labelContainer);
                        }
                    } catch (e) {
                        console.warn('خطأ في قراءة بيانات المنتج:', e);
                    }
                }
            });
        },
        
        addLimitedStockLabel: function(container) {
            const existingLabel = container.querySelector('.label-limited-stock');
            if (existingLabel) return;
            
            const limitedLabel = document.createElement('span');
            limitedLabel.className = 't4s-shopee-label label-limited-stock size-small animation-pulse';
            limitedLabel.style.cssText = 'background: #ff6b6b; color: #fff;';
            limitedLabel.textContent = 'كمية محدودة';
            
            container.appendChild(limitedLabel);
        },
        
        applyDynamicTheme: function() {
            const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
            
            if (isDarkMode) {
                document.documentElement.style.setProperty('--shopee-label-shadow', '0 2px 6px rgba(255, 255, 255, 0.1)');
                document.documentElement.style.setProperty('--payment-square-shadow', '0 2px 4px rgba(255, 255, 255, 0.1)');
            } else {
                document.documentElement.style.setProperty('--shopee-label-shadow', '0 2px 6px rgba(0, 0, 0, 0.2)');
                document.documentElement.style.setProperty('--payment-square-shadow', '0 2px 4px rgba(0, 0, 0, 0.15)');
            }
        },
        
        optimizePositioning: function() {
            const products = document.querySelectorAll('.t4s-product.has-shopee-labels.has-payment-squares');
            
            products.forEach(product => {
                const labelContainer = product.querySelector('.t4s-shopee-labels');
                const paymentContainer = product.querySelector('.t4s-payment-squares');
                
                if (labelContainer && paymentContainer) {
                    const labelPosition = labelContainer.classList.contains('position-bottom-left') || 
                                        labelContainer.classList.contains('position-bottom-right');
                    const paymentPosition = paymentContainer.classList.contains('position-bottom-left') || 
                                          paymentContainer.classList.contains('position-bottom-right');
                    
                    if (labelPosition && paymentPosition) {
                        labelContainer.style.bottom = '40px';
                    }
                }
            });
        }
    };
    
    ShopeeLabels.init();
    
    setTimeout(() => {
        ShopeeLabels.addDynamicLabels();
        ShopeeLabels.optimizePositioning();
    }, 1000);
    
    ShopeeLabels.applyDynamicTheme();
    
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        ShopeeLabels.applyDynamicTheme();
    });
    
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        return originalFetch.apply(this, args).then(response => {
            setTimeout(() => {
                ShopeeLabels.handleResponsiveLabels();
                ShopeeLabels.handleResponsivePaymentSquares();
                ShopeeLabels.addLabelInteractions();
                ShopeeLabels.addPaymentSquareInteractions();
                ShopeeLabels.optimizePositioning();
            }, 500);
            return response;
        });
    };
    
    console.log('✅ نظام تسميات Shopee ومربعات الدفع تم تحميله بنجاح');
});

const additionalCSS = `
.t4s-shopee-labels.has-multiple-labels {
    animation: subtle-glow 3s ease-in-out infinite alternate;
}

.t4s-payment-squares.has-multiple-payments {
    animation: payment-glow 4s ease-in-out infinite alternate;
}

@keyframes subtle-glow {
    0% { filter: brightness(1); }
    100% { filter: brightness(1.1); }
}

@keyframes payment-glow {
    0% { filter: brightness(1) saturate(1); }
    100% { filter: brightness(1.05) saturate(1.1); }
}

.shopee-more-indicator:hover,
.payment-more-indicator:hover {
    transform: scale(1.1);
    transition: transform 0.2s ease;
}

.t4s-shopee-label,
.t4s-payment-square {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (max-width: 480px) {
    .t4s-shopee-labels,
    .t4s-payment-squares {
        max-width: calc(100% - 16px);
    }
}

.t4s-payment-square {
    box-shadow: var(--payment-square-shadow, 0 2px 4px rgba(0, 0, 0, 0.15));
}
`;

const styleSheet = document.createElement('style');
styleSheet.textContent = additionalCSS;
document.head.appendChild(styleSheet);